import '../styles/About.css';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';

export default function About() {
  const { t, language } = useLanguage();
  const navigate = useNavigate();

  // Pick the right PDF per language (fallback to SK)
  const priceHref = {
    sk: '/images/cennik_sk.pdf',
    cz: '/images/cennik_cz.pdf',
    en: '/images/cennik_en.pdf',
  }[language] || '/images/cennik_sk.pdf';

  return (
    <div className='about-outer-wrapper'>
      <div className="container">
        <div className="about-inside-wrapper">

          <h1>{t('AboutPage.header')}</h1>

          <p>{t('AboutPage.paragraph1')}</p>
          <p>{t('AboutPage.paragraph2')}</p>

          <h2>{t('AboutPage.when-header')}</h2>
          <ul className="about-list">
            {t('AboutPage.when-list').map((item, idx) => (
              <li key={`when-${idx}`}>{item}</li>
            ))}
          </ul>

          <h2>{t('AboutPage.benefits-header')}</h2>
          <ul className="about-list">
            {t('AboutPage.benefits-list').map((item, idx) => (
              <li key={`benefit-${idx}`}>{item}</li>
            ))}
          </ul>

          <h2>{t('AboutPage.for-header')}</h2>
          <ul className="about-list">
            {t('AboutPage.for-list').map((item, idx) => (
              <li key={`for-${idx}`}>{item}</li>
            ))}
          </ul>

          <button
            className="about-button"
            onClick={() => window.open('images/ukazka_z_merania.pdf', '_blank')}
          >
            {t('AboutPage.button-sample')}
          </button>

          <button
            className="about-button"
            onClick={() => navigate('/contact#contact-form')}
          >
            {t('AboutPage.button-order')}
          </button>

          {/* ✨ Price list by language */}
          <button
            className="about-button"
            onClick={() => window.open(priceHref, '_blank')}
          >
            {t('AboutPage.button-pricelist')}
          </button>

        </div>
      </div>
    </div>
  );
}